$.fn.slotPicker = function () {
  this.each((i, el) => {
    const availableSlots = JSON.parse(el.dataset.availableSlots)
    const $container = $(el)
    const $deliveryDateSelect = $container.find('select[name="delivery[delivery_date]"]')
    const $deliverySlotSelect = $container.find('select[name="delivery[delivery_slot]"]')

    $deliveryDateSelect.on('change', (e) => {
      if (!e.target.value) return

      const [, slots] = availableSlots.find(([date]) => date === e.target.value)
      $deliverySlotSelect.html('')
        .append(new Option('', ''))
      slots.forEach(([text, value]) => {
        $deliverySlotSelect.append(new Option(text, value))
      })
    })
  })
  return this
}
